import React from "react";
import { useIntl } from "react-intl";
import { Form, Row, Col } from "antd";

import Adr from "./adr";
import Fdd from "./fdd";
import DateRange from "./dateRange";
import Incoterms from "./incoterms";
import Insurance from "./insurance";
import EuroPallet from "./euroPallet";
import EkServices from "./ekServices";
import ErServices from "./erServices";
import BcServices from "./bcServices";
import Manipulation from "./manipulation";
import CashOnDelivery from "./cashOnDelivery";
import ServiceWithDate from "./serviceWithDate";
import DomesticServices from "./domesticServices";
import NationalTransportId from "./nationalTransportId";
import TextAreaItem from "../../app/generic/textAreaItem";
import ServiceWithParameter from "./serviceWithParameter";
import InternationalServices from "./internationalServices";
import LoadErrorText from "../../app/generic/loadErrorText";

import "./index.css";

function ServicesForm({
  form,
  rules,
  detail,
  collis,
  product,
  wrappings,
  currencies,
  templateWork,
  pickupCountry,
  onSetAdrCount,
  invoiceAddress,
  initialServices,
  deliveryCountry,
  onSetCarryToFloor,
  onCashTransportPay,
  countOfEuroPallets,
  deliveryCountryCurrencies,
}) {
  const intl = useIntl();
  const { getFieldDecorator } = form;
  const formItemLayout = {
    labelCol: {
      sm: 5,
      xxl: 5,
    },
    wrapperCol: {
      sm: 16,
      xxl: 12,
    },
    colon: false,
  };

  return (
    <Form {...formItemLayout} className="services-form">
      <Row>
        <Col>
          {rules === "e" && (
            <LoadErrorText
              message={intl.formatMessage({
                id: "consignment.services.formLoadError",
                defaultMessage:
                  "Při načítání Vám dostupných služeb nastala chyba, opakujte prosím načtení formuláře!",
              })}
            />
          )}
          <Insurance
            rules={rules}
            disabled={detail}
            product={product}
            currencies={currencies}
            formItemLayout={formItemLayout}
            adr={form.getFieldValue("adr")}
            initialServices={initialServices}
            getFieldDecorator={getFieldDecorator}
            deliveryCountryCurrencies={deliveryCountryCurrencies}
          />
          {(product.code === "ECD_B2B" || product.code === "ECD_B2C") && (
            <DomesticServices
              rules={rules}
              mainForm={form}
              disabled={detail}
              product={product}
              invoiceAddress={invoiceAddress}
              initialServices={initialServices}
              onCashTransportPay={onCashTransportPay}
            />
          )}
          <EuroPallet
            rules={rules}
            mainForm={form}
            collis={collis}
            disabled={detail}
            wrappings={wrappings}
            initialServices={initialServices}
            countOfEuroPallets={countOfEuroPallets}
          />
          {(product.code === "ERI" ||
            product.code === "ERD" ||
            product.code === "PPI") && (
            <ErServices
              disabled={detail}
              formItemLayout={formItemLayout}
              initialServices={initialServices}
              getFieldDecorator={getFieldDecorator}
            />
          )}
          {(product.code === "ECI" ||
            product.code === "SPI" ||
            product.code === "ECI_B2C") && (
            <EkServices
              disabled={detail}
              initialServices={initialServices}
              getFieldDecorator={getFieldDecorator}
            />
          )}
          {(product.code === "ERI" ||
            product.code === "ERD" ||
            product.code === "PPI" ||
            product.code === "ECI" ||
            product.code === "SPI" ||
            product.code === "ECI_B2C") && (
            <InternationalServices
              disabled={detail}
              productCode={product.code}
              initialServices={initialServices}
              getFieldDecorator={getFieldDecorator}
            />
          )}
          {(product.code === "ERI" ||
            product.code === "PPI" ||
            product.code === "ECI" ||
            product.code === "SPI" ||
            product.code === "ELI" ||
            product.code === "ECI_B2C") && (
            <NationalTransportId
              disabled={detail}
              pickupCountry={pickupCountry}
              formItemLayout={formItemLayout}
              deliveryCountry={deliveryCountry}
              initialServices={initialServices}
              getFieldDecorator={getFieldDecorator}
            />
          )}
          {product.code !== "ELD" &&
            product.code !== "ELI" &&
            product.code !== "ERI" &&
            product.code !== "ERD" &&
            product.code !== "PPI" && (
              <CashOnDelivery
                rules={rules}
                mainForm={form}
                disabled={detail}
                product={product}
                pickupCountry={pickupCountry}
                formItemLayout={formItemLayout}
                deliveryCountry={deliveryCountry}
                getFieldDecorator={getFieldDecorator}
                deliveryCountryCurrencies={deliveryCountryCurrencies}
                cashOnDelivery={
                  initialServices && initialServices.cashOnDelivery
                }
              />
            )}
          <Adr
            rules={rules}
            collis={collis}
            mainForm={form}
            disabled={detail}
            onSetAdrCount={onSetAdrCount}
            formItemLayout={formItemLayout}
            initialServices={initialServices}
            getFieldDecorator={getFieldDecorator}
          />
          {product.code === "ECD_B2C" && (
            <BcServices
              rules={rules}
              mainForm={form}
              disabled={detail}
              initialServices={initialServices}
              onSetCarryToFloor={onSetCarryToFloor}
            />
          )}
          {product.code !== "ECD_B2B" &&
            product.code !== "ECD_B2C" &&
            product.code !== "ERD" && (
              <Incoterms
                disabled={detail}
                productCode={product.code}
                formItemLayout={formItemLayout}
                initialServices={initialServices}
                getFieldDecorator={getFieldDecorator}
              />
            )}
          {product.code === "ELI" || product.code === "ELD" ? (
            <>
              <DateRange
                pickup
                disabled={detail}
                formItemLayout={formItemLayout}
                initialDateFrom={
                  initialServices && initialServices.pickupDateTime
                }
                initialDateTo={
                  initialServices && initialServices.pickupDateTimeTo
                }
                getFieldDecorator={getFieldDecorator}
              />
              <DateRange
                disabled={detail}
                formItemLayout={formItemLayout}
                initialDateFrom={
                  initialServices && initialServices.deliveryDateTime
                }
                initialDateTo={
                  initialServices && initialServices.deliveryDateTimeTo
                }
                getFieldDecorator={getFieldDecorator}
              />
            </>
          ) : (
            <>
              <ServiceWithDate
                detail={detail}
                disabled={detail}
                checkDate={!detail}
                productId={product.id}
                label={intl.formatMessage({
                  id: "consignment.services.pickupDate",
                  defaultMessage: "Datum svozu",
                })}
                fieldName="pickupDateTime"
                getNearest={!templateWork}
                formItemLayout={formItemLayout}
                fromToday={rules.sameDayPickup}
                getFieldDecorator={getFieldDecorator}
                countryId={pickupCountry && pickupCountry.id}
                initialServiceDate={
                  initialServices && initialServices.pickupDateTime
                }
              />
              {(product.code === "ECI" ||
                product.code === "SPI" ||
                product.code === "ECI_B2C") && (
                <Fdd
                  rules={rules}
                  disabled={detail}
                  productId={product.id}
                  formItemLayout={formItemLayout}
                  initialServices={initialServices}
                  getFieldDecorator={getFieldDecorator}
                  countryId={deliveryCountry && deliveryCountry.id}
                />
              )}
            </>
          )}
          {product.code !== "ELI" && product.code !== "ELD" && (
            <>
              <Manipulation
                pickup
                disabled={detail}
                label={intl.formatMessage({
                  id: "consignment.services.pickupHandling",
                  defaultMessage: "Manipulace svoz",
                })}
                initialServices={initialServices}
                getFieldDecorator={getFieldDecorator}
              />
              <Manipulation
                disabled={detail}
                label={intl.formatMessage({
                  id: "consignment.services.deliveryHandling",
                  defaultMessage: "Manipulace rozvoz",
                })}
                initialServices={initialServices}
                getFieldDecorator={getFieldDecorator}
              />
            </>
          )}
          <ServiceWithParameter
            label={intl.formatMessage({
              id: "consignment.services.notes",
              defaultMessage: "Poznámky k přepravě",
            })}
          >
            <TextAreaItem
              allowClear
              disabled={detail}
              fieldName="notes"
              getFieldDecorator={getFieldDecorator}
              autoSize={{ minRows: 3, maxRows: 6 }}
              initialValue={initialServices && initialServices.notes}
            />
          </ServiceWithParameter>
        </Col>
      </Row>
    </Form>
  );
}

export default Form.create()(ServicesForm);
